const list = {
  // =================================================================================================================
  components () {
    return [
      {'component': 'search-start-end', "label": '작성일', "value":'date', "query":{'ss':'startDate', 'ee':'endDate'}, "options":{}},
      {'component': 'search-column-keyword',
        "label": '검색조건',
        "value":'column',
        "query":{'ck_t':'head', 'ck_k':'keyword'},
        "options": { hiddenList: ['작성일', '선임상태', '교육 이수여부']}},
    ]
  },
  getConditions: (nav) => {
    const conditions = [];
    const search = nav.value;

    //  작성일
    if (search.date) {
      conditions.push({key: 'created_at', operator: '>=', value: search.date.startDate})
      conditions.push({key: 'created_at', operator: '<', value: search.date.endDate ? new Date(search.date.endDate).addDays(1).format("yyyy-MM-dd") : ''})
    }

    //  검색조건
    const heads = list.getHead().map(e => { return {[e.name] : e.key} });
    // 배열의 객체들을 하나의 객체로 합치기
    const types = Object.assign({}, ...heads);
    if (search.column && search.column.keyword) {
      conditions.push({key: types[search.column.head], operator: 'LIKE', value: `%${search.column.keyword}%`})
    }
    return conditions;
  },


  // =================================================================================================================
  getHead: () => {
    return [
      {
        "name": "사업장명",
        "key": "body.stdInfo.field_name"
      },
      {
        "name": "관리감독자",
        "key": "body.inputC_1"
      },
      {
        "name": "소속명",
        "key": "body.inputC_2"
      },
      {
        "name": "선임상태",
        "key": "body.inputC_5"
      },
      {
        "name": "교육 이수여부",
        "key": "body.inputC_7"
      },
      {
        "name": "부서명",
        "key": "body.stdInfo.section"
      },
      {
        "name": "작성자",
        "key": "body.stdInfo.writer_name"
      },
      {
        "name": "작성일",
        "key": "created_at"
      }
    ]
  },
  getCol: (index, value, func) => {
    try {
      switch (index) {
        case 0:
          return func.getContent(value).stdInfo.field_name // 사업장명
        case 1:
          return func.getContent(value).inputC_1 // 관리감독자
        case 2:
          return func.getContent(value).inputC_2  // 소속명
        case 3: // 선임상태
          let 선임상태 = ''
          if (func.getContent(value).inputC_5) {
            if (func.getContent(value).inputC_5 !== '') {
              선임상태 = '선임'
              if (func.getContent(value).inputC_6 && func.getContent(value).inputC_6 !== '') {
                선임상태 = '종료'
              }
            }
          }
          return 선임상태
        case 4: // 이수여부
          let 이수여부 = ''
          if (func.getContent(value).inputC_7) {
            if (func.getContent(value).inputC_7 !== '') {
              이수여부 = '이수'
            } else {
              이수여부 = '미이수'
            }
          }
          return 이수여부
        case 5:
          return func.getContent(value).stdInfo.section // 부서명
        case 6:
          return func.getContent(value).stdInfo.writer_name // 작성자
        case 7:
          return func.getCreatedDate(value.created_at) // 작성일
      }
    } catch (ignore) { /*ignore*/ }
    return ''
  },
  getSearchKeyValue: (nav) => {},
  getSearchKeyword: (nav) => {},
}
export default list;
